import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAddButton = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <circle cx={12} cy={12} r={12} fill="#E5E6EB" />
    <path
      stroke="#787887"
      strokeLinecap="round"
      d="M12 8.5V12M12 12V15.5M12 12H8.5M12 12H15.5"
    />
  </svg>
);
export default SvgAddButton;
